module.exports = __webpack_public_path__ + "img/50.ecd6e280.png";